import styled from "styled-components";
import { RollFromBottom } from "../ui/animations";

const Title = styled.h1`
  font-size: 72px;
  text-transform: ${({ dash }) => (dash ? "uppercase" : "none")};
  font-weight: ${({ bold=true }) => (bold ? "bold" : "normal")};
  width: ${({ width }) => (width ? width : "auto")};
  margin: 0;
  animation: ${RollFromBottom} 1.75s ease;
  /* animation-delay: 1.75s; */
  @media screen and (max-width: 1500px) {
    font-size: 48px;
  }
  
  @media screen and (max-width: 1100px) {
    font-size: 48px;
  }
  @media screen and (max-width: 400px) {
    font-size: 36px;
  }
  ${({ dash }) => {
    if (dash) {
      return `
        margin-left: 1.75em;
        position: relative;
        ::before {
          content: "";
          display: block;
          position: absolute;
          left: -1.75em;
          top: 50%;
          transform: translateY(-50%);
          width: 1.25em;
          height: 10px;
          background-color: white;
        }
      `;
    }
  }}
`;

export default Title;
